// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__W3-A0","loader":"Loading_loader__38LJF","flor":"Loading_flor__PLqhI","giro":"Loading_giro__2Z_-V"};